import { fetcher } from "helpers/fetcher";

import { PaginationReq } from "../types";
import { TGetProfileListRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserStaffList = async (payload: PaginationReq) => {
  return await fetcher<TGetProfileListRes, PaginationReq>(
    ENDPOINT.USER.USER_STAFF_LIST,
    {
      data: payload,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.USER_CLIENT_LIST.version,
      },
    }
  );
};

export const queryGetUserStaffList = async (payload: PaginationReq) => {
  return (await getUserStaffList(payload)).data;
};

queryGetUserStaffList._key = (payload: PaginationReq) => [
  ENDPOINT.USER.USER_STAFF_LIST.url,
  payload,
];
